import { Flex, Heading, Spinner } from '@workshop/ui';
import { useAuthMethods } from 'hooks/auth';
import useCheckout from 'hooks/checkout';
import navRoutes from 'navigation/Routes';
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { SignupForm } from 'screens/Signup/SignupForm';
import { getParamFromUrl } from 'utils';

const logoLarge = require('../../../assets/logo_large.png');
const onionImg = require('../../../assets/onion_mat@3x.png');

const SignupScreen: React.FC<{ history: any }> = ({ history }) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const { initCheckout, priceId, postCheckoutInProgress } = useCheckout({
    loadingState: { isLoading, setIsLoading },
    history,
    eventId: 'web_app_signup',
  });

  const { onSubmit } = useAuthMethods({
    authCallback: initCheckout,
    loadingState: { isLoading, setIsLoading },
  });

  const location = useLocation();
  const couponCode = getParamFromUrl(location, 'coupon_code');

  useEffect(() => {
    // Attempting to sign up without a priceId or coupon code should redirect to the subscribe page
    // -- (as there is nothing else to access post-signup)

    if (!priceId) {
      history.push(navRoutes.public.subscribe.path());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [couponCode, priceId]);

  return (
    <Flex flexDir={['column', 'column', 'row']}>
      {postCheckoutInProgress && (
        <Flex
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          zIndex={1000}
          justifyContent="center"
          alignItems="center"
        >
          <Flex
            position="fixed"
            top={0}
            left={0}
            right={0}
            bottom={0}
            zIndex={1000}
            bgColor="black"
            opacity={0.2}
          />
          <Spinner />
        </Flex>
      )}
      <Helmet>
        <title>Sidekick - Sign up</title>
      </Helmet>
      <Flex
        display={['none', 'none', 'flex']}
        backgroundImage={logoLarge}
        width="140px"
        height="30px"
        position="absolute"
        left={4}
        bottom={4}
        backgroundSize="contain"
        backgroundRepeat="no-repeat"
        backgroundPosition="bottom"
      />
      <Flex
        alignItems="center"
        backgroundColor="primary"
        flex="0 0 40%"
        flexDirection="column"
        height={['0', '0', '100vh']}
        justifyContent="flex-start"
        pb={['5', '5', '0']}
        pt={['5', '5', '40']}
        px={['0', '0', '0']}
      >
        <Heading display={['flex', 'flex', 'none']} fontSize={['2xl', '2xl', '4xl']}>
          Sign Up to Sidekick
        </Heading>
        <Flex
          display={['none', 'none', 'block']}
          width="100%"
          height="20vw"
          backgroundImage={onionImg}
          backgroundRepeat="no-repeat"
          backgroundSize="contain"
          backgroundPosition="center"
        />
      </Flex>
      <Flex
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="center"
        minHeight="100vh"
        backgroundColor="white"
        flex={1}
        px={['10', '10', '20']}
        pt={['10', '10', '0']}
      >
        <Flex pt={['0', '0', '20']} width="100%" />
        <Heading display={['none', 'none', 'flex']} fontSize={['2xl', '2xl', '4xl']} mb="8">
          Sign Up to Sidekick
        </Heading>
        <SignupForm onSubmit={onSubmit} isLoading={isLoading} />
      </Flex>
    </Flex>
  );
};

export default SignupScreen;
